var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEditor)?_c('a',{staticClass:"u-message el-button el-button--warning el-button--medium u-op-public",on:{"click":_vm.onButtonClick}},[_c('i',{staticClass:"el-icon-message"}),_c('span',[_vm._v("私信")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }